import { render } from "./AuditoriaDato.vue?vue&type=template&id=e798f8ec"
import script from "./AuditoriaDato.vue?vue&type=script&lang=js"
export * from "./AuditoriaDato.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__